import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmationDialogComponent
} from "@k2/common/dialogs/components/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'checkbox-action',
  templateUrl: './checkbox-action.component.html',
  styleUrls: ['./checkbox-action.component.scss'],
  standalone: false

})
export class CheckboxActionComponent {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() checked: boolean | null = false;
  @Input() confirmMsg: string = 'Are you sure?';
  @Input() withConfirm: boolean = false;
  @Input() confirmButtonText: string = 'Yes';
  @Input() cancelButtonText: string = 'No';
  @Input() onConfirm: () => void;
  @Input() onCancel: () => void;

  @Output() checkedChange = new EventEmitter<boolean | null>();

  constructor(private dialog: MatDialog) {}

  onCheckboxChange(event: any) {
    let newValue: boolean | null = event.target.checked;

    if (!this.withConfirm) {
      this.checked = newValue;
      this.checkedChange.emit(this.checked);
      if (this.onConfirm) this.onConfirm();
      return;
    }

    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        text: this.confirmMsg,
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
        onSubmit: () => {
          this.checked = newValue;
          this.checkedChange.emit(this.checked);
          if (this.onConfirm) this.onConfirm();
        },
        onCancel: () => {
          // Revert checkbox
          event.target.checked = !newValue;
          if (this.onCancel) this.onCancel();
        }
      }
    });
  }
}
